/* Label-Wert-Paare von DetailList nebeneinander statt untereinander (Vertragsabschluss). */
.person-overview-inline-details.mq-detail-list {
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: var(--mq-space-xl);
  row-gap: var(--mq-space-md);
}

.person-overview-inline-value {
  display: inline-flex;
  align-items: center;
  gap: var(--mq-space-xxs);
}

.person-overview-studio-select {
  min-width: 220px;
}

/* Karte „Handlungsbedarf": je Eintrag Text links, eine Aktion rechts. */
.person-overview-todo-list {
  display: flex;
  flex-direction: column;
  gap: var(--mq-space-sm);
  margin: 0;
  padding: 0;
  list-style: none;
}

.person-overview-todo-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--mq-space-sm);
  flex-wrap: wrap;
  min-width: 0;
}

/* Karte „Mitgliedschaft": Pakete, Geldwerte, Zutrittsmedien mit gleichmäßigem Abstand. */
.person-overview-membership {
  display: flex;
  flex-direction: column;
  gap: var(--mq-space-xl);
}

/* Zutrittsmedien (Personenübersicht und Check-in): eine Zeile je Medium, Löschen rechts. */
.person-access-media-list {
  display: flex;
  flex-direction: column;
  gap: var(--mq-space-xxs);
  margin: 0;
  padding: 0;
  list-style: none;
}

.person-access-media-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--mq-space-sm);
  min-width: 0;
}

.person-access-media-label {
  display: inline-flex;
  align-items: center;
  gap: var(--mq-space-xs);
  min-width: 0;
}


/* ---------- Kennzahlen aller Übersichtsblöcke (OverviewKpi): genau drei Schriftgrößen ----------
 * Beschriftung (klein, Versalien), Wert (eine Größe für Zahlen und Wörter), Zusatzzeile. Nichts daneben. */
/* Breite nach Inhalt, verteilt über die Zeile: lange Werte (Stammstudio) werden nicht in gleich breite Spalten gezwängt. */
.person-overview-kpis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--mq-space-lg) var(--mq-space-xl);
}

/* Kennzahlen, die zusammengehören (Mitgliedschaft): links beginnend statt über die Zeile verteilt. */
.person-overview-kpis--start {
  justify-content: flex-start;
  column-gap: calc(var(--mq-space-xl) * 2);
}

.person-overview-kpi {
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  gap: var(--mq-space-xxs);
  min-width: 0;
  max-width: 100%;
}

.person-overview-kpi--access {
  flex-direction: row;
  align-items: center;
  gap: var(--mq-space-sm);
}

.person-overview-access-ring {
  display: grid;
  flex: none;
  place-items: center;
  width: calc(var(--mq-space-xl) * 2);
  height: calc(var(--mq-space-xl) * 2);
  border: var(--mq-space-xxs) solid var(--mq-theme-line);
  border-radius: var(--mq-pill-radius);
  color: var(--mq-theme-text-2);
  font-size: var(--mq-font-size-title-md);
  line-height: var(--mq-line-height-solid);
}

.person-overview-kpi[data-tone="ok"] .person-overview-access-ring { border-color: var(--mq-kit-ok); color: var(--mq-kit-ok); }
.person-overview-kpi[data-tone="warn"] .person-overview-access-ring { border-color: var(--mq-kit-warn); color: var(--mq-kit-warn); }
.person-overview-kpi[data-tone="error"] .person-overview-access-ring { border-color: var(--mq-theme-signal); color: var(--mq-theme-signal); }

.person-overview-kpi-stack {
  display: flex;
  flex-direction: column;
  gap: var(--mq-space-xxs);
  min-width: 0;
}

.person-overview-kpi-label {
  overflow: hidden;
  color: var(--mq-theme-text-2);
  font-size: var(--mq-font-size-xs);
  letter-spacing: 0.06em;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.person-overview-kpi-value {
  overflow: hidden;
  color: var(--mq-theme-text);
  font-family: var(--mq-theme-display);
  font-size: var(--mq-font-size-page-title);
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  line-height: var(--mq-line-height-tight);
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Stammstudio: der Name kürzt sich, der Stift zum Ändern bleibt sichtbar. */
.person-overview-kpi-value .person-overview-inline-value {
  display: flex;
  max-width: 100%;
}

.person-overview-kpi-ellipsis {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.person-overview-kpi-refresh {
  vertical-align: middle;
  font-size: var(--mq-font-size-sm);
}

.person-overview-kpi-sub {
  color: var(--mq-theme-text-2);
  font-size: var(--mq-font-size-sm);
}

.person-overview-kpi .ck-progress {
  margin-top: var(--mq-space-xxs);
}

.person-overview-kpi[data-tone="ok"] .person-overview-kpi-value--word { color: var(--mq-kit-ok); }
.person-overview-kpi[data-tone="warn"] .person-overview-kpi-value,
.person-overview-kpi[data-tone="warn"] .person-overview-kpi-sub { color: var(--mq-kit-warn); }
.person-overview-kpi[data-tone="error"] .person-overview-kpi-value { color: var(--mq-theme-signal); }

/* ---------- Handlungsbedarf: Kurzetiketten, die selbst die Aktion sind ---------- */
.person-overview-chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--mq-space-xs);
  margin: 0;
  padding: 0;
  list-style: none;
}

.person-overview-chip.ck-btn,
.person-overview-chip--static {
  border-radius: var(--mq-pill-radius);
}

.person-overview-chip--static {
  display: inline-flex;
  align-items: center;
  padding: var(--mq-space-xxs) var(--mq-space-sm);
  border: 1px solid currentColor;
  font-size: var(--mq-font-size-sm);
}

.person-overview-chip[data-tone="error"] { border-color: var(--mq-theme-signal); color: var(--mq-theme-signal); }
.person-overview-chip[data-tone="warn"] { border-color: var(--mq-kit-warn); color: var(--mq-kit-warn); }

/* ---------- Anwesenheit: Kennzahlen, darunter das Wochenraster ---------- */
.person-attendance {
  display: flex;
  flex-direction: column;
  gap: var(--mq-space-xl);
}

.person-attendance-trend {
  display: inline-flex;
  align-items: center;
  gap: var(--mq-space-xxs);
  font-variant-numeric: tabular-nums;
}

.person-attendance-trend[data-tone="up"] { color: var(--mq-kit-ok); }
.person-attendance-trend[data-tone="down"] { color: var(--mq-theme-signal); }

.person-attendance-heatmap {
  display: grid;
  grid-template-columns: repeat(13, minmax(0, 1fr));
  gap: var(--mq-space-xs);
}

.person-attendance-week {
  display: grid;
  gap: var(--mq-space-xs);
  min-width: 0;
}

/* Feste Feldhöhe statt Quadrat: in breiten Karten würde das Raster sonst höher als der Rest des Blocks. */
.person-attendance-day {
  display: block;
  height: var(--mq-space-sm);
  border-radius: calc(var(--mq-control-radius) / 2);
  background: var(--mq-theme-fill);
}

.person-attendance-day[data-level="1"] { background: color-mix(in srgb, var(--mq-theme-primary) 40%, var(--mq-theme-fill)); }
.person-attendance-day[data-level="2"] { background: color-mix(in srgb, var(--mq-theme-primary) 70%, var(--mq-theme-fill)); }
.person-attendance-day[data-level="3"] { background: var(--mq-theme-primary); }
.person-attendance-day[data-future] { background: transparent; }
